import React, { useEffect, useState } from "react";
import { galleryApi, getImageUrl } from "../api";
import ImageLoader from "./common/ImageLoader";
import "./AdminGallery.css";

const AdminGallery = () => {
  const [images, setImages] = useState([]);
  const [imageFile, setImageFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchImages();
  }, []);

  const fetchImages = async () => {
    try {
      const res = await galleryApi.getAll();
      setImages(res.data || []);
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!imageFile) return alert("Please select an image.");

    setLoading(true);
    const formData = new FormData();
    formData.append("image", imageFile);

    try {
      await galleryApi.upload(formData);
      setImageFile(null);
      setPreviewUrl(null);
      e.target.reset();
      fetchImages();
      alert("✅ Uploaded photo to gallery!");
    } catch (err) {
      console.error("Upload error:", err);
      alert("❌ Upload failed");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this photo permanently from the gallery?")) return;

    try {
      await galleryApi.delete(id);
      fetchImages();
      alert("🗑️ Photo deleted!");
    } catch (err) {
      console.error("Delete error:", err);
      alert("❌ Delete failed");
    }
  };

  return (
    <div className="admin-gallery-wrapper">
      <div className="admin-panel-header">
        <div className="panel-title-group">
          <i className="fas fa-camera-retro title-icon"></i>
          <div>
            <h2>Manage Chapter Gallery</h2>
            <p className="panel-subtitle">Upload moments, workshop snapshots, awards, and hackathon highlights</p>
          </div>
        </div>
      </div>

      <div className="gallery-layout-grid">
        {/* Upload Box */}
        <div className="upload-box-card">
          <h3 className="sub-heading-tag"><i className="fas fa-cloud-upload-alt"></i> Upload New Photo</h3>
          <form className="admin-glass-form" onSubmit={handleUpload}>
            <div className="admin-form-group">
              <label>Select Photo (JPG, PNG, WEBP)</label>
              <input type="file" accept="image/*" onChange={handleFileChange} required />
            </div>

            {previewUrl && (
              <div className="image-preview-wrapper">
                <img src={previewUrl} alt="Preview" />
              </div>
            )}

            <button type="submit" className="admin-btn-primary" disabled={loading}>
              {loading ? (
                <>
                  <i className="fas fa-circle-notch fa-spin"></i> Uploading...
                </>
              ) : (
                <>
                  <i className="fas fa-upload"></i> Upload to Gallery
                </>
              )}
            </button>
          </form>
        </div>

        {/* Gallery Grid */}
        <div className="gallery-showcase-card">
          <h3 className="sub-heading-tag">
            <i className="fas fa-photo-video"></i> Chapter Moments ({images.length})
          </h3>

          {images.length === 0 ? (
            <p className="no-items-text">No gallery images uploaded yet.</p>
          ) : (
            <div className="gallery-masonry-grid">
              {images.map((img) => (
                <div className="gallery-masonry-item" key={img.id}>
                  <ImageLoader src={getImageUrl(img.imagePath)} alt={`Gallery item ${img.id}`} />
                  <div className="gallery-item-overlay">
                    <span className="gallery-id-chip">#{img.id}</span>
                    <button
                      className="delete-img-btn"
                      onClick={() => handleDelete(img.id)}
                      title="Delete photo"
                    >
                      <i className="fas fa-trash-alt"></i>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminGallery;